import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n/i18n";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { PageTitle, Panel } from "@/pages/app/kit";
import { Metric } from "@/components/shared";
import { ArrowRight } from "lucide-react";

export default function DashboardHome() {
  const { t } = useT();
  const { user } = useAuth();
  const [impact, setImpact] = useState(null);

  useEffect(() => { api.get("/impact").then((r) => setImpact(r.data)).catch(() => {}); }, []);

  const primary = {
    farmer: ["/app/crops", t("cta.registerCrop")],
    buyer: ["/app/demand", t("cta.registerDemand")],
    processor: ["/app/processing", t("dashboard.capacity")],
    coordinator: ["/app/rescue", t("dashboard.rescue")],
    investor: ["/app/investor", t("dashboard.investor")],
  }[user.role] || ["/app/rescue", t("dashboard.rescue")];

  return (
    <div>
      <PageTitle title={`${t("dashboard.welcome")}, ${user.name}`} subtitle={t(`roles.${user.role}`)} />
      {impact && (
        <div className="mb-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
          <Metric label="kg registered (demo)" value={impact.food.kg_registered.toLocaleString()} />
          <Metric label="kg matched (demo)" value={impact.food.kg_matched.toLocaleString()} />
          <Metric label="crops at risk" value={impact.operational.crops_at_risk} />
          <Metric label="approved matches" value={impact.operational.matches} />
        </div>
      )}
      <Panel title={t("dashboard.overview")}>
        <p className="text-sm text-mutedtext">{t("home.doctrine")}</p>
        <Link to={primary[0]} className="mt-4 inline-flex items-center gap-2 rounded-md bg-forest px-4 py-2.5 text-sm font-semibold text-white hover:bg-forestdark" data-testid="primary-action">
          {primary[1]} <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </Panel>
    </div>
  );
}
